<ion-content class="page-content">
  <ion-grid style="padding-top: 0">
    <ion-row
      class="cookie-settings-section"
      [ngClass]="isModal ? 'modal-view' : ''"
    >
      <ion-col *ngIf="isModal" size="12"
        ><h3 class="popup-header">Cookie settings</h3></ion-col
      >
      <ion-col size="12" class="explanation">
        <div>
          <p class="cookies-general-info">
            Cookies are files saved on your device when you visit a website or
            web application. We use cookies to collect and store information
            about how you use Cloudia. We don’t use any marketing cookies. If
            you want to know more about cookies we use,
            <a href="{{ '/' + tenant + '/cookie-policy' }}" target="_blank"
              >see our Cookie policy</a
            >
          </p>
        </div>
      </ion-col>
    </ion-row>
    <ion-row
      class="ion-justify-content-between ion-align-items-end cookie-settings-section"
      [ngClass]="isModal ? 'modal-view' : ''"
      ><ion-col
        size-xl="8"
        size-lg="7"
        size-md="7"
        size-sm="7"
        size-xs="6"
        style="padding-top: 0"
        ><div>
          <h4>Strictly necessary cookies</h4>
          <p class="cookie-type-description">
            Cookies that enable the basic features of the application, such as
            providing secure log-in or adjusting your consent preferences.
          </p>
        </div></ion-col
      ><ion-col
        size-xl="2"
        size-lg="2"
        size-md="2"
        size-sm="3"
        size-xs="4"
        style="padding-top: 0; align-self: center"
      >
        <div class="ion-text-end">
          <p class="active-label">Always active</p>
        </div>
      </ion-col>
    </ion-row>
    <ion-row
      class="ion-justify-content-between cookie-settings-section"
      [ngClass]="isModal ? 'modal-view' : ''"
    >
      <ion-col
        size-xl="8"
        size-lg="7"
        size-md="7"
        size-sm="7"
        size-xs="6"
        style="padding-top: 0"
      >
        <div>
          <h4>Analytical cookies</h4>
          <p class="cookie-type-description">
            These cookies gather information such as how you accessed the
            application, the pages you visit, the time spent on each page, and
            the actions you take while visiting. They collect only anonymised
            data and are very helpful to us, allowing us to study users
            behaviour so that we can provide better user experience.
          </p>
        </div>
      </ion-col>
      <ion-col
        size-xl="3"
        size-lg="4"
        size-md="5"
        size-sm="5"
        size-xs="6"
        style="padding-top: 0; align-self: center"
      >
        <div
          class="ion-text-end"
          style="display: flex; align-items: center; justify-content: end"
        >
          <div class="toogle-label">
            {{ cookiesStatusControl.value ? 'Enabled' : 'Disabled' }}
          </div>
          <ion-toggle
            [checked]="cookiesStatusControl.value"
            slot="end"
            style="padding-left: 8px; padding-right: 8px"
            [formControl]="cookiesStatusControl"
          >
          </ion-toggle>
        </div>
      </ion-col>
    </ion-row>
    <ion-row
      *ngIf="isModal"
      class="ion-justify-content-between cookie-settings-section modal-view"
      style="margin-bottom: 0"
    >
      <ion-col size-xs="12" class="save-button-wrapper">
        <ion-button (click)="saveChanges($event)">{{
          isModal ? 'Save & close' : 'Save changes'
        }}</ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
